import { createContext, useContext } from 'react';

import { DateRangeChange } from 'ui/datePicker/types';
import noop from 'utils/noop';

export interface EventFilterState {
  dateRange: DateRangeChange;
  setDateRange: (newRange: DateRangeChange) => void;
  isFiltering: boolean;
}

const defaultContext: EventFilterState = {
  dateRange: {
    startDate: null,
    endDate: null,
  },
  setDateRange: noop,
  isFiltering: false,
};

export const EventFilterContext = createContext<EventFilterState>(defaultContext);

export const useEventFilterContext = () => useContext(EventFilterContext);
